import React from 'react';
import Industries from '../components/Industries';

const IndustriesPage = () => {
  return (
    <main className="reveal-fade">
      <Industries />
    </main>
  );
};

export default IndustriesPage;
